import React from 'react';
import Header from './components/Header';
import ChatInterface from './components/ChatInterface';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <ChatInterface />
      </main>
    </div>
  );
}

export default App;
